import {
  getSpotPayloadForBookSpot,
  normalizeSpot,
  type RoomLayoutSpot,
} from '@glofoxinc/room-layout-map/interactiveSpotBooking';

export interface SpotEventContext {
  spotTypePrefix: string;
  spotNumber: string;
}

export function getSpotEventContext(spot: RoomLayoutSpot | null): SpotEventContext | null {
  if (!spot) {
    return null;
  }
  return {
    spotTypePrefix: spot.spot_type_prefix ?? '',
    spotNumber: getSpotPayloadForBookSpot(normalizeSpot(spot)) ?? '',
  };
}
